import { render, staticRenderFns } from "./fertilizerManagement2.vue?vue&type=template&id=207aadc8&scoped=true"
import script from "./fertilizerManagement2.vue?vue&type=script&lang=js"
export * from "./fertilizerManagement2.vue?vue&type=script&lang=js"
import style0 from "./fertilizerManagement2.vue?vue&type=style&index=0&id=207aadc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207aadc8",
  null
  
)

export default component.exports